module.exports = __webpack_public_path__ + "static/img/5.064efb1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/zh/5.png
// module id = XO9m
// module chunks = 0